import { render, staticRenderFns } from "./layout-filter-window.vue?vue&type=template&id=9064a1c4&scoped=true&"
import script from "./layout-filter-window.vue?vue&type=script&lang=js&"
export * from "./layout-filter-window.vue?vue&type=script&lang=js&"
import style0 from "./layout-filter-window.vue?vue&type=style&index=0&id=9064a1c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9064a1c4",
  null
  
)

export default component.exports